import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LANGUAGE_STORAGE_KEY} from '../enums/language.enum';

/**
 * Interceptor that attaches the user's chosen UI language as the `Accept-Language`
 * HTTP header on every outgoing request. The language is read from `localStorage`
 * (key `LANGUAGE_STORAGE_KEY`), which is managed by `TranslatorService`.
 *
 * This ensures the backend resolves translations in the same language the user
 * selected in the client UI, instead of falling back to the browser's default locale.
 */
@Injectable()
export class LanguageInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    try {
      const language = localStorage.getItem(LANGUAGE_STORAGE_KEY);
      if (language) {
        const localizedRequest = request.clone({
          setHeaders: {'Accept-Language': language}
        });
        return next.handle(localizedRequest);
      }
    } catch {
      // localStorage may throw (e.g. SecurityError in restricted environments).
      // Fall through and forward the request without the header.
    }
    return next.handle(request);
  }
}
